<template>
  <ul class="nav nav-mobile-menu">
    <drop-down>
      <template slot="title">
        <i class="nc-icon nc-bullet-list-67"></i>
      </template>
      <router-link to="/user_settings" class="dropdown-item" :active-class="''">
        <i class="nc-icon nc-settings-90"></i> {{ $store.state.authUser ? $store.state.authUser.name : '' }}
      </router-link>
      <a href="#" class="dropdown-item text-danger" @click.prevent="logout">
        <i class="nc-icon nc-button-power"></i> Log out
      </a>
    </drop-down>
  </ul>
</template>
<script>
import DropDown from 'src/components/Dropdown.vue'

export default {
  components: {
    DropDown
  },

  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login')
      }).catch(err => {
        console.log(err)
      })
    },
  }

}

</script>
<style></style>
